<template>
  <div class="pop" ref="filterPop" :style="{left: `${x}px`, top: `${y}px`}">
    <el-checkbox-group v-model="checkList">
      <div class="itembox" v-for="(item, i) in vals" :key="i">
        <el-checkbox v-if="isArr" :label="item.value">{{item.label}}</el-checkbox>
        <el-checkbox v-else :label="item" />
      </div>
    </el-checkbox-group>
    <div class="btns">
      <el-button type="text" size="mini" @click="handleFilter">筛选</el-button>
      <el-button type="text" size="mini" @click="handleReset">重置</el-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    isOpen: {
      type: Boolean, // sync
      default: false
    },
    rect: {
      type: Object,
      default: () => {}
    },
    vals: {
      type: Array,
      default: () => []
    },
    selectList: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    const {
      x,
      y,
      width,
      height
    } = this.rect
    return {
      x: x + width,
      y: y - height,
      width,
      checkList: this.selectList
    }
  },
  computed: {
    isArr() {
      const arr = ['radio', 'checkbox', 'select']
      if (_.includes(arr, this.type)) {
        return true
      }
      return false
    }
  },
  mounted() {
    this.$nextTick(() => {
      const body = document.querySelector('body')
      if (body.append) {
        body.append(this.$el)
      } else {
        body.appendChild(this.$el)
      }
      this.setY()
    })

    document.addEventListener('click', (e) => {
      if (this.$refs.filterPop) {
        const boxRect = this.$refs.filterPop.getBoundingClientRect()
        const targetRect = e.target.getBoundingClientRect()
        // console.log(rect, targetRect)
        const {
          x,
          y
        } = targetRect
        const isX = x >= boxRect.x && x <= boxRect.x + boxRect.width
        const isY = y >= boxRect.y && y <= boxRect.y + boxRect.height
        if ((isX && isY) || (x === this.rect.x && y === this.rect.y)) {
        // console.log(true)
        } else {
          this.setIsOpen()
        }
      }
    })
  },
  destroyed() {
    document.removeEventListener('click', this.setIsOpen, true)
    //
  },
  methods: {
    documentClick() {

    },
    setIsOpen() {
      this.$emit('update:isOpen', false)
    },
    setY() {
      const rect = this.$refs.filterPop.getBoundingClientRect()
      this.y = this.y - rect.height + 15
      this.x -= rect.width
    },
    handleFilter() {
      this.setIsOpen()
      this.emitList()
    },
    handleReset() {
      this.checkList = []
      this.setIsOpen()
      this.emitList()
    },
    emitList() {
      this.$emit('on-filter', this.checkList)
    }
  }
}
</script>

<style lang="scss" scoped>
.pop {
position: fixed;
  z-index: 2001;
  background-color: #FFF;
  border: 1px solid #eee;
}
.btns {
  border-top: 1px solid #eee;
  padding:5px 10px;
}
.itembox {
  padding: 5px 10px;
}
</style>
